import booking from './booking-reducer';

export * from './booking-reducer';
export default booking;
